<template>
  <div>
    <div class="mt-1">
      <b-row
        ><b-col md="9"><h3>Customer Report</h3></b-col>
        <b-col md="3">
          <div class="text-right">
            <b-button
              variant="primary"
              class="ml-5"
              @click="
                $router.push({ name: 'history', params: { type: 'CUSTOMER' } })
              "
              >View Download History</b-button
            >
          </div></b-col
        ></b-row
      >
      <b-row>
        <b-col md="8">
          <h4>Customer Registration Report</h4>
        </b-col>
        <b-col md="1">
          <img
            src="@/assets/images/DataExport.png"
            class="upload-btn ml-4"
            alt="data export"
            @click="createRequest"
          />
        </b-col>
        <b-col md="3">
          <eb-select
            style="background-color: #fff"
            id="text"
            type="text"
            label="text"
            :options="dateOption"
            v-model="selectedDate"
            :selected="selectedDate.text"
            @input="changeDate"
          >
          </eb-select>
          <b-modal
            title="Select Date"
            header-class="header-nipige-class"
            id="dateRange"
            size="sm"
            ref="date-range"
            centered
            hide-footer
          >
            <b-input class="mb-2" type="date" v-model="startDate"></b-input>
            <b-input type="date" v-model="endDate"></b-input>
            <div class="text-center mt-2">
              <b-button
                @click="findButtonClick()"
                class="my -0 main-navigation-button w-47 mr-2"
                variant="success"
                >Find
              </b-button>
            </div>
          </b-modal>
        </b-col>
      </b-row>
      <div
        v-if="
          this.$currentUserData.category == 'TA' ||
          this.$currentUserData.category == 'DISTRIBUTOR' ||
          this.$currentUserData.category == 'DEALER' ||
          this.$currentUserData.category == 'SELLER' ||
          $userRole == 'Tenant' ||
          $userRole == 'Admin'
        "
      >
        <BarChart value="daily-registration" :chart-data="chartData" />
      </div>
      <div v-else>
        <h4 class="text-center my-5">No Data Available</h4>
      </div>
    </div>
  </div>
</template>
<script>
import ebSelect from "@/components/FormElements/Select.vue";
import BarChart from "@/components/chart/BarChart";
import moment from "moment";
import dailyRegistrationChartData from "@/utils/dailyRegistrationChartData";
export default {
  name: "Reports",
  components: {
    BarChart,
    ebSelect,
  },
  data() {
    return {
      chartOptions: {
        hoverBorderWidth: 10,
      },
      selectedDate: {
        text: "Today",
        value: 1,
      },
      dateOption: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 day's",
          value: 7,
        },
        {
          text: "30 day's",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      startDate: "",
      endDate: "",
    };
  },
  computed: {
    userId() {
      if (this.$store.getters["auth/getUserID"]) {
        return this.$store.getters["auth/getUserID"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
      }
    },
    chartData() {
      let data = this.$store.getters["partner/GetBulkAnalyticsRept"];
      let dailyRegistrationKey = "";
      let registrationCount = "";
      let dayCount = "";
      if (this.$currentUserData.category == "TA") {
        dailyRegistrationKey = "daily-registration-graph";
        registrationCount = "count";
        dayCount = "day";
      } else if (this.$currentUserData.category === "SELLER") {
        dailyRegistrationKey = "seller-daily-registration-graph";
        registrationCount = "count";
        dayCount = "day";
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        dailyRegistrationKey = "subdealer-daily-registration-graph";
        registrationCount = "count";
        dayCount = "day";
      }
      const dailyRegistration = data[dailyRegistrationKey];
      return dailyRegistrationChartData(
        dailyRegistration,
        registrationCount,
        dayCount
      );
    },
  },
  methods: {
    findButtonClick() {
      let e = {
        fromDate: this.startDate,
        toDate: this.endDate,
      };
      this.$refs["date-range"].hide();
      this.getAnalyticsData();
      this.fetchRequest();
    },
    changeDate(e) {
      this.selectedDate = e;
      if (e.value == "custom") {
        this.$refs["date-range"].show();
        return;
      }
      this.getAnalyticsData();
      this.fetchRequest();
    },
    async getAnalyticsData() {
      if (this.$currentUserData.category === "TA") {
        const payload = {
          items: [
            {
              key: "daily-registration-graph",
              variables: {
                ...this.getDateData(this.selectedDate.value),
                tenant: this.userId,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchBulkAnalyticReport", payload);
      } else if (this.$currentUserData.category === "SELLER") {
        const payload = {
          items: [
            {
              key: "seller-daily-registration-graph",
              variables: {
                ...this.getDateData(this.selectedDate.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchBulkAnalyticReport", payload);
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        const payload = {
          items: [
            {
              key: "subdealer-daily-registration-graph",
              variables: {
                ...this.getDateData(this.selectedDate.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchBulkAnalyticReport", payload);
      }
    },
    getDateData(dateData) {
      if (dateData == "custom") {
        const data = {
          fromDate: this.startDate,
          toDate: this.endDate,
        };
        return data;
      }
      if (dateData == 1) {
        const data = {
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        return data;
      } else {
        const data = {
          fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        if (typeof dateData === "number") {
          data.fromDate = moment()
            .subtract(dateData - 1, "days")
            .format("YYYY-MM-DD");
          return data;
        } else if (typeof dateData === "object") {
          return dateData;
        }
        return data;
      }
    },
    createRequest() {
      const payload = {
        filterBy: {
          ...this.getDateData(this.selectedDate.value),
          collectionName: "CUSTOMER",
        },
        requestBy: {
          _id: this.$currentUserData._id,
          name: this.$currentUserData.userName,
          email: this.$currentUserData.email,
          phone: this.$currentUserData.phone,
        },
      };
      this.$store
        .dispatch("bulkNotification/createRequestDownload", payload)
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Request successful!!",
            type: "success",
          });
        })
        .catch((error) =>
          this.$toasted.error(
            error.message ? error.message : "Error Request could not completed"
          )
        );
      this.fetchRequest();
    },
  },

  mounted() {
    this.getAnalyticsData();
  },
};
</script>
<style scoped>
.upload-btn {
  height: 39px;
}
</style>
